import React from 'react';

const TokenDrawer = ({ isOpen, onClose, title, tokens, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className='token-drawer-overlay' onClick={onClose}>
      <div
        className='token-drawer-content'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='token-drawer-header'>
          <h5 className='mb-0' style={{ color: 'var(--text-primary)' }}>{title}</h5>
          <button className='btn-close-drawer' onClick={onClose}>
            <i className='fas fa-times'></i>
          </button>
        </div>

        <div className='token-list-container'>
          <div className='token-list'>
            {tokens.map((token, index) => (
              <div
                key={index}
                className='token-item'
                onClick={() => {
                  onSelect(token);
                  onClose();
                }}
              >
                <img
                  src={token.img}
                  alt={token.tag}
                  className='token-item-img'
                />
                <div className='token-item-info'>
                  <span className='token-item-symbol'>{token.tag}</span>
                  {/* Optional: Add full name if available in object */}
                </div>
                {/* Optional: Add balance if passed */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenDrawer;
